/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Currency from 'react-currency-formatter';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Barcode from 'react-barcode';
import moment from 'moment';
import TagManager from 'react-gtm-module';

import { BiSync } from 'react-icons/bi';
import PixCode from 'newComponents/PixCode';
import firebase from 'services/firebase';
import api from 'services/api';
import CustomToolip from './CustomToolip';

import {
  Container,
  Header,
  Left,
  BackButton,
  ButtonWrap,
  Title,
  CloseIcon,
  Content,
  CustomerInfoContainer,
  IconLabel,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  DetailsContainer,
  SectionTitle,
  Link,
  InvoiceNumber,
  DetailsContent,
  StatusContainer,
  StatusIcon,
  BankSlipContainer,
  TypeableLineContainer,
  TypeableLineText,
  ToolTipText,
  TypeableLineIcon,
  ToolTipButton,
  BarcodeContainer,
  BarcodeContent,
  BarcodeResponsive,
  RemoveSpace,
  DuplicateContainer,
  DuplicateButton,
  DuplicateIcon,
  DuplicateLoading,
  StatusText,
  DuplicateText,
  PaymentWrap,
  PaymentInfos,
  InfoTextPix,
  ReactTooltipPix,
  UpdatePixContainer,
  MobileInfoTooltipWrap,
  MobileInfoTooltipContainer,
  MobileInfoTooltipTitle,
  MobileInfoTooltipText,
} from './styles';

class Boletos extends Component {
  constructor() {
    super();
    this.state = {
      copyId: null,
      copyPixId: null,
      token: null,
      payment: [],
      installment: {},
      customer: {},
      invoice: {},
      loading: false,
      loadingDownload: false,
      loadingEmail: false,
      status: null,
      qrCodeDataState: null,
    };
  }

  componentDidMount() {
    const { payment, installment } = this.props;
    const { qrcodeData } = installment;
  
    if (qrcodeData) {
      let cleanQrcodeData = qrcodeData.trim();
      cleanQrcodeData = cleanQrcodeData.replace('"dados_qrcode" : ', '');

      try {
        const parsedData = JSON.parse(cleanQrcodeData);
        this.setState({ qrCodeDataState: parsedData });
      } catch (error) {
        console.error("Erro ao analisar o JSON:", error);
      }
    }
    this.organizeData(payment, installment);
    this.handleStatus(installment);
  }

  componentDidUpdate(prevProps) {
    const { installment } = this.props;

    if (prevProps?.installment?.status !== installment?.status) {
      this.handleStatus(installment);
      console.log({ prevProps, newProp: this.props });
    }
  }

  organizeData = async (payment, installment) => {
    this.setState({ loading: true });
    const { customer } = payment;
    const invoice = payment;
    return await this.setState({
      token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      invoice,
      customer,
      installment,
    });
  };

  convertLine = (dados) => {
    const line = `${dados}`;
    const bank = line.substring(0, 3);
    const coin = line.substring(3, 4);
    const camp = line.substring(4, 9);
    const camp1 = line.substring(9, 10);
    const camp2 = line.substring(10, 20);
    const camp3 = line.substring(20, 21);
    const camp4 = line.substring(21, 31);
    const camp5 = line.substring(31, 32);
    const camp6 = line.substring(32, 47);
    const result = bank + coin + camp6 + camp + camp2 + camp4;
    return result;
  };

  handleStatus = (installment) => {
    const currentDate = new Date();
    const dueDate = new Date(installment.dueDate);
    dueDate.setDate(dueDate.getDate() + 1);
    if (installment.paymentStatus === 'OP') {
      if (currentDate > dueDate) this.setState({ status: 'Vencido' });
      if (currentDate <= dueDate) this.setState({ status: 'A vencer' });
    } else {
      this.setState({ status: 'Pago' });
    }
  };

  requestDownloadBoleto = () => {
    this.setState({ loadingDownload: true });
    const { customer, invoice, installment, token } = this.state;
    firebase.analytics().logEvent('download_boleto', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: 'DOWNLOAD',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((blob) => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${this.state.installment.installmentId}.pdf`
        );
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        this.setState({ loadingDownload: false });
      })
      .catch((err) => {
        this.setState({ loadingDownload: false });
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  requestEmailBoleto = () => {
    firebase.analytics().logEvent('email_boleto', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        email_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        email_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    this.setState({ loadingEmail: true });
    const { customer, invoice, installment, token } = this.state;
    const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: 'EMAIL',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((res) => {
        this.setState({ loadingEmail: false });
        toast.success(`Boleto enviado para o e-mail: ${email}`);
      })
      .catch((err) => {
        this.setState({ loadingEmail: false });
      });
  };

  handleCopyToClickBoard = (copyId) => {
    this.setState({
      copyId,
      copyPixId: null,
    });
  };

  handleCopyPixToClickBoard = (copyPixId) => {
    this.setState({
      copyPixId,
      copyId: null,
    });
  };

  render() {
    console.log({ newProps: this.props });
    const { close, back, setCloseModal, showMobileMode } = this.props;
    const {
      installment,
      customer,
      invoice,
      copyId,
      copyPixId,
      loading,
      loadingDownload,
      loadingEmail,
      qrCodeDataState,
    } = this.state;

    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton title="Fechar" className="mdi mdi-arrow-left" />
            ) : null}
            <Title>Detalhes da cobrança</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <CustomerInfoContainer>
            <Info>
              <InfoTitle>Cliente:</InfoTitle>
              <InfoText>{customer.name}</InfoText>
            </Info>
            <Info className="mt-2">
              <InfoTitle>Endereço:</InfoTitle>
              <InfoText>
                <>
                  {`${customer.address}, ${customer.addressNumber} - ${customer.county} - ${customer.city} - ${customer.stateCode}`}
                </>
              </InfoText>
            </Info>
          </CustomerInfoContainer>
          <Hr />
          <DetailsContainer>
            <SectionTitle>Detalhes</SectionTitle>
            <DetailsContent>
              <Info>
                <InfoTitle>Número da Nota:</InfoTitle>
                <Link
                  to={`/notas?invoice-number=${this.props.payment.invoiceNumber}`}
                >
                  <InvoiceNumber>{invoice.invoiceNumber}</InvoiceNumber>
                </Link>
              </Info>
              <Info>
                <InfoTitle>Vencimento:</InfoTitle>
                <InfoText>
                  {moment(installment.dueDate).format('DD/MM/YYYY')}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Valor:</InfoTitle>
                <InfoText>
                  <Currency
                    quantity={installment.amountOriginal}
                    currency="BRL"
                    locale="pt"
                  />
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Status:</InfoTitle>
                <StatusContainer>
                  <StatusIcon
                    color={
                      this.state.status === 'Pago'
                        ? '#75B943'
                        : this.state.status === 'Vencido'
                        ? '#e34e2a'
                        : this.state.status === 'A vencer'
                        ? '#f0b01b'
                        : '#000'
                    }
                  />
                  <StatusText>{this.state.status}</StatusText>
                </StatusContainer>
              </Info>
            </DetailsContent>
            {installment.paymentTypeBoleto && this.state.status !== 'Pago' ? (
              <>
                <Hr />
                <BankSlipContainer>
                  <PaymentWrap>
                    <PaymentInfos>
                      <SectionTitle>Boleto de Cobrança</SectionTitle>
                      <Info style={{ marginTop: '10px' }}>
                        <InfoTitle>Linha Digitável:</InfoTitle>
                        <TypeableLineContainer>
                          <InfoText>{installment.typeableLine}</InfoText>
                          <CopyToClipboard text={installment.typeableLine}>
                            <ToolTipButton
                              onClick={() =>
                                this.handleCopyToClickBoard(
                                  installment.typeableLine
                                )
                              }
                              data-tip
                              data-for="copy"
                            >
                              <TypeableLineIcon className="mdi mdi-content-copy" />
                            </ToolTipButton>
                          </CopyToClipboard>
                          <ReactTooltip
                            id="copy"
                            place="right"
                            effect="solid"
                            type="info"
                          >
                            <ToolTipText>
                              {copyId === installment.typeableLine &&
                              copyPixId === null
                                ? 'Copiado'
                                : 'Clique para copiar'}
                            </ToolTipText>
                          </ReactTooltip>
                        </TypeableLineContainer>
                      </Info>
                      <BarcodeContainer className="mt-2">
                        <Info>
                          <InfoTitle>Código de Barras:</InfoTitle>
                          <BarcodeContent>
                            <Barcode
                              format="ITF"
                              displayValue={false}
                              width={1}
                              height={70}
                              background="#ffffff"
                              style={{ width: '100%' }}
                              value={this.convertLine(installment.typeableLine)}
                            />
                          </BarcodeContent>
                          <BarcodeResponsive>
                            <Barcode
                              format="ITF"
                              displayValue={false}
                              width={0.6}
                              height={70}
                              background="#ffffff"
                              value={this.convertLine(installment.typeableLine)}
                            />
                          </BarcodeResponsive>
                        </Info>
                      </BarcodeContainer>
                    </PaymentInfos>
                    {qrCodeDataState?.emv && (
                      <PaymentInfos>
                        <UpdatePixContainer>
                          <SectionTitle>Pague com PIX</SectionTitle>
                          {!showMobileMode && (
                            <CustomToolip
                              title="Já efetuou o pagamento?"
                              componentShow={() => (
                                <span>
                                  Clique aqui para atualizar o status do boleto
                                </span>
                              )}
                            >
                              <BiSync
                                color="#0000ff"
                                size={22}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setCloseModal(true)}
                              />
                            </CustomToolip>
                          )}
                          {showMobileMode && (
                            <BiSync
                              color="#0000ff"
                              size={22}
                              style={{ cursor: 'pointer' }}
                              onClick={() => setCloseModal(true)}
                            />
                          )}
                        </UpdatePixContainer>
                        <>
                          {showMobileMode && (
                            <MobileInfoTooltipWrap>
                              <MobileInfoTooltipContainer>
                                <MobileInfoTooltipTitle>
                                  Já efetuou o pagamento?
                                </MobileInfoTooltipTitle>
                                <MobileInfoTooltipText>
                                  <span>Clique em</span>
                                  <span>
                                    <BiSync color="#0000ff" size={18} />
                                  </span>
                                  <span>para atualizar o status do boleto</span>
                                </MobileInfoTooltipText>
                              </MobileInfoTooltipContainer>
                            </MobileInfoTooltipWrap>
                          )}
                        </>
                        <Info style={{ marginTop: '10px' }}>
                          <InfoTitle>Código Copia e Cola</InfoTitle>
                          <TypeableLineContainer>
                            <InfoTextPix>{qrCodeDataState?.emv}</InfoTextPix>
                            <CopyToClipboard text={qrCodeDataState?.emv}>
                              <ToolTipButton
                                onClick={() => {
                                  this.handleCopyPixToClickBoard(
                                    qrCodeDataState?.emv
                                  );
                                }}
                                data-tip
                                data-for="copy-pix"
                              >
                                <TypeableLineIcon className="mdi mdi-content-copy" />
                              </ToolTipButton>
                            </CopyToClipboard>
                            <ReactTooltipPix
                              id="copy-pix"
                              place="right"
                              effect="solid"
                              type="info"
                            >
                              <ToolTipText>
                                {copyPixId === qrCodeDataState?.emv &&
                                copyId === null
                                  ? 'Copiado'
                                  : 'Clique para copiar'}
                              </ToolTipText>
                            </ReactTooltipPix>
                          </TypeableLineContainer>
                        </Info>
                        <BarcodeContainer className="mt-2">
                          <Info>
                            <InfoTitle>QR Code:</InfoTitle>
                            <BarcodeContent>
                              <PixCode size={90} value={qrCodeDataState?.emv} />
                            </BarcodeContent>
                            <BarcodeResponsive>
                              <PixCode size={90} value={qrCodeDataState?.emv} />
                            </BarcodeResponsive>
                          </Info>
                        </BarcodeContainer>
                      </PaymentInfos>
                    )}
                  </PaymentWrap>

                  <Hr />
                  {invoice.source === 'COLETORES' && (
                    <>
                      {invoice.accessKey && (
                        <DuplicateContainer>
                          <DuplicateText>2ª via de boleto</DuplicateText>
                          <ButtonWrap>
                            <IconLabel>Download</IconLabel>
                            <DuplicateButton
                              onClick={() => this.requestDownloadBoleto()}
                            >
                              {loadingDownload ? (
                                <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                              ) : (
                                <DuplicateIcon
                                  className="mdi mdi-cloud-download-outline"
                                  aria-label="Download"
                                />
                              )}
                            </DuplicateButton>
                          </ButtonWrap>
                          <ButtonWrap>
                            <IconLabel>Enviar boleto por e-mail</IconLabel>
                            <DuplicateButton
                              onClick={() => this.requestEmailBoleto()}
                            >
                              {loadingEmail ? (
                                <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                              ) : (
                                <DuplicateIcon
                                  className="mdi mdi-email-outline"
                                  aria-label="Enviar boleto por e-mail"
                                />
                              )}
                            </DuplicateButton>
                          </ButtonWrap>
                        </DuplicateContainer>
                      )}
                    </>
                  )}
                </BankSlipContainer>
              </>
            ) : (
              <RemoveSpace />
            )}
          </DetailsContainer>
        </Content>
      </Container>
    );
  }
}

export default connect()(Boletos);
